import React from 'react'
import { useValues } from 'kea'

import GeneralHeader from '~/scenes/header'
import HeaderFilter from '~/scenes/search/filters-page/header-filter'

import sceneLogic from '~/scenes/search/logic'

export default function Header () {
  const { isSmallScreen, headerProps, filter } = useValues(sceneLogic)

  return (
    <GeneralHeader
      {...headerProps}
      searchedQuery={
        filter.query && !((filter.main_category_ids || []).length > 0 && (filter.sub_category_ids || []).length === 0)
          ? filter.query
          : ''
      }
      isMinHeader={isSmallScreen}
    >
      <HeaderFilter />
    </GeneralHeader>
  )
}
